import React, { FC, useState } from 'react'
import { useSelector } from 'react-redux'
import { DsStack, DsTypography } from '@am92/react-design-system'

import withPageConstants, {
  IWithPageConstantsProps
} from '~/src/Hocs/withPageConstants'

import ButtonError from '~/src/Components/ChildLayout/ButtonError'
import ChildPopup from '~/src/Components/ChildLayout/ChildPopup'

import TRIAL_NUDGE_POPUP_PAGE_CONSTANTS from './TrialNudgePopup.PageConstants'
import { T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS } from './TrialNudgePopup.PageConstants/TYPES'

import { getUserReducer } from '~/src/Redux/User/Selectors'

interface TrialNudgePopupProps {}

const TrialNudgePopup: FC<
  TrialNudgePopupProps &
    IWithPageConstantsProps<T_TRIAL_NUDGE_POPUP_PAGE_CONSTANTS>
> = props => {
  const { PAGE_CONSTANTS } = props
  const [open, setOpen] = useState<boolean>(true)
  const user = useSelector(getUserReducer)

  if (user.subscriptionType !== 'FREE') {
    return null
  }

  const onClose = () => setOpen(false)

  return (
    <ChildPopup open={open} onClose={onClose} showClose={false}>
      <DsStack spacing='var(--ds-spacing-glacial)'>
        <DsTypography
          variant='subheadingSemiboldDefault'
          sx={{ mb: 'var(--ds-spacing-glacial) !important' }}
        >
          {PAGE_CONSTANTS.TITLE}
        </DsTypography>
        <DsTypography variant='bodyRegularSmall'>
          {PAGE_CONSTANTS.DESCRIPTION.replace(
            '{subscriptionExpireOn}',
            `${user.subscriptionExpireOn}`
          )}
        </DsTypography>
      </DsStack>
      <DsStack
        direction='row'
        spacing='var(--ds-spacing-bitterCold)'
        justifyContent='flex-end'
        sx={{
          mt: {
            xs: 'var(--ds-spacing-mild)',
            md: 'var(--ds-spacing-warm)'
          }
        }}
      >
        <ButtonError size='small' onClick={onClose}>
          {PAGE_CONSTANTS.CTA_TEXT}
        </ButtonError>
      </DsStack>
    </ChildPopup>
  )
}

export default withPageConstants(
  TRIAL_NUDGE_POPUP_PAGE_CONSTANTS,
  TrialNudgePopup
)
